import { api_get } from '../../util'

const state = {
  list: [],
  loading: false,
  fullLoading: false,
  lastUrl: null,
  lastQuery: null
}

// getters
const getters = {
  count: state => {
    return state.list.length
  }
}

// actions
const actions = {
  fetchList ({ commit, state, rootState, rootGetters }, payload) {
    let url = ''
    let query = rootGetters['filter/query']
    let first = 10

    if (rootState.filter.search) {
      url = `item/search/${rootState.filter.search}/${rootState.filter.nutri_id}`
      first = 0
    }
    else if (rootState.filter.category_id) {
      url = `item/list/${rootState.filter.category_id}/${rootState.filter.nutri_id}`
    }
    else {
      url = `item/list/${rootState.filter.nutri_id}`
    }
    return new Promise((resolve, reject) => {
      if (url == state.lastUrl && JSON.stringify(query) == state.lastQuery && !payload.full) {
        reject('no update')
      }
      else {
        if (!payload.full) {
          commit('loading', true)
        }
        else {
          first = 0
          commit('fullLoading', true)
        }
        api_get(url, Object.assign({}, query, {first: first})).then(res => {
          commit('setLast', {url, query})
          commit('loading', false)
          commit('fullLoading', false)
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      }
    })
  },
}

// mutations
const mutations = {
  setList (state, list) {
    state.list = list
  },
  setLast (state, payload) {
    state.lastUrl = payload.url
    state.lastQuery = JSON.stringify(payload.query)
  },
  loading (state, value) {
    state.loading = value
  },
  fullLoading (state, value) {
    state.fullLoading = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/item.js